<template>
  <div class="no_data">
    <img src="./img/empty.png" alt="" />
    <slot></slot>
    <slot name="btn"></slot>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss">
.no_data {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 188px;
    margin-bottom: 10px;
    font-size: 18px;
    color: rgba(34, 34, 34, 1);
  }
}
</style>
